module.exports = __webpack_public_path__ + "img/1440.b5b7bfac.jpg";